export const conditionalRedirection = {
    // "_id" : ObjectId("637f1cc0dc278d9af514a369"),
    // "wf_id" : ObjectId("637f1cc8dc278d9af514a36a"),
    // "organisation_id" : ObjectId("63b517305f0c894cfb1496ec"),
    "wf_name" : "kotak-kmfsl",
    "client_logo" : "kotak-adgm-logo",
    "created_by" : "",
    "created_at" : "",
    "is_active" : true,
    "is_deleted" : false,
    "last_updated_at" : "",
    "last_updated_by" : "",
    "configuration_history" : [ 
        {
            "changes" : {},
            "module" : "",
            "updated_by" : "",
            "updated_at" : ""
        }
    ],
    "wf_journey" : [ 
        {
            "step" : 1,
            "module_name" : "Conditional Redirection",
            "form_structure" : {
                "name" : "onboard_form",
                "layout" : "regular",
                "nav_orientation" : "horizontal",
                "allignment_position" : "left",
                "custom_style" : "class_name_1 class_name_2",
                "sections" : [ 
                    {
                        "type" : "banner",
                        "title" : "",
                        "orientation" : "horizontal",
                        "custom_styles" : "classname_1 classname_2",
                        "occupancy" : "30%",
                        "show" : "localStorage.getItem(\"userToken\") == null",
                        "content_type" : "html",
                        "content" : "<div><h3>Create your account</h3><div style='color: '><h5>Onboard yourself in few steps</h5></div></div>"
                    }, 
                    {
                        "type" : "banner",
                        "title" : "",
                        "orientation" : "horizontal",
                        "custom_styles" : "classname_1 classname_2",
                        "occupancy" : "30%",
                        "show" : "localStorage.getItem(\"userToken\")?.length",
                        "content_type" : "html",
                        "content" : "<div><h3>RM Initiated</h3><h5>Add a new customer in just a few steps</h5><p>Fill up the details and sent them the link for email verification</p></div>"
                    }, 
                    {
                        "title" : "Account Selection",
                        "name" : "account_selection",
                        "order" : 1,
                        "show" : true,
                        "form_groups" : [ 
                            {
                                "title" : "Account Information",
                                "name" : "account_information",
                                "order" : 1,
                                "show" : true,
                                "next_step" : 2,
                                "form_elements" : [ 
                                    {
                                        "type" : "radio",
                                        "label" : "Choose what type of client you are",
                                        "name" : "application_type",
                                        "options" : [ 
                                            {
                                                "label" : "Individual",
                                                "id" : "option1",
                                                "for" : "individual"
                                            }, 
                                            {
                                                "label" : "Entity",
                                                "id" : "option2",
                                                "for" : "entity",
                                                "is_disabled" : "true"
                                            }
                                        ],
                                        "validators" : {
                                            "required" : true,
                                            "pattern" : [],
                                            "min_length" : "",
                                            "max_length" : ""
                                        },
                                        "error_messages" : {
                                            "min_error" : "",
                                            "max_error" : "",
                                            "pattern_error" : "",
                                            "required_error" : "This field is mandatory"
                                        }
                                    }, 
                                    {
                                        "type" : "dropdown",
                                        "id" : "mode_of_operation",
                                        "label" : "Mode of operation",
                                        "name" : "mode_of_operation",
                                        "size" : "col-lg-12 col-md-12 col-sm-12",
                                        "name" : "service_type",
                                        "default_value" : "CRN and Investment Services",
                                        "placeholder" : "Investment Service",
                                        "disabled" : true,
                                        "validators" : {
                                            "required" : true,
                                            "pattern" : [],
                                            "min_length" : "",
                                            "max_length" : ""
                                        },
                                        "error_messages" : {
                                            "min_error" : "",
                                            "max_error" : "",
                                            "pattern_error" : "",
                                            "required_error" : "This field is mandatory"
                                        }
                                    }
                                ],
                                "form_buttons" : [ 
                                    {
                                        "label" : "Next",
                                        "action" : "next"
                                    }
                                ]
                            }, 
                            {
                                "title" : "User Information",
                                "name" : "workflows_generation",
                                "order" : 2,
                                "show" : true,
                                "next_step" : 3,
                                "form_elements" : [ 
                                    {
                                        "type" : "recursive",
                                        "title" : "Applicant Information",
                                        "show" : true,
                                        "custom_styles" : "classname_1",
                                        "min_length" : 1,
                                        "max_length" : 15,
                                        "recursive_title" : "Details of added member",
                                        "input_fields" : [ 
                                            {
                                                "type" : "subheader",
                                                "name" : "subheader_for_applicant",
                                                "label" : "Primary applicant information",
                                                "show" : "recursive?.saveData?.length === 0"
                                            }, 
                                            {
                                                "type" : "dropdown",
                                                "id" : "title",
                                                "label" : "Title",
                                                "name" : "title",
                                                "size" : "col-lg-12 col-md-12 col-sm-12 ",
                                                "placeholder" : "title",
                                                "show" : true,
                                                "options" : [ 
                                                    {
                                                        "label" : "Select",
                                                        "id" : "option1",
                                                        "for" : "option1",
                                                        "value" : ""
                                                    }, 
                                                    {
                                                        "label" : "Mr",
                                                        "id" : "option2",
                                                        "for" : "option2"
                                                    }, 
                                                    {
                                                        "label" : "Mrs",
                                                        "id" : "option3",
                                                        "for" : "option3"
                                                    }, 
                                                    {
                                                        "label" : "Ms",
                                                        "id" : "option4",
                                                        "for" : "option4"
                                                    }, 
                                                    {
                                                        "label" : "Dr",
                                                        "id" : "option5",
                                                        "for" : "option5"
                                                    }, 
                                                    {
                                                        "label" : "Other",
                                                        "id" : "option6",
                                                        "for" : "option6"
                                                    }
                                                ],
                                                "validators" : {
                                                    "required" : true,
                                                    "pattern" : [],
                                                    "min_length" : "",
                                                    "max_length" : ""
                                                },
                                                "error_messages" : {
                                                    "min_error" : "You have to enter atleast <x> characters",
                                                    "max_error" : "You cant enter more than <x> characters",
                                                    "pattern_error" : "Please select the appropriate title",
                                                    "required_error" : "This field is mandatory"
                                                }
                                            }, 
                                            {
                                                "type" : "text",
                                                "id" : "other_title",
                                                "label" : "Enter title",
                                                "size" : "col-lg-12 col-md-12 col-sm-12 ",
                                                "name" : "other_title",
                                                "placeholder" : "Eg: Kevin",
                                                "show" : "recursive.recursiveFormData.title == \"Other\"",
                                                "validators" : {
                                                    "required" : true,
                                                    "pattern" : [],
                                                    "min_length" : 2,
                                                    "max_length" : 30
                                                },
                                                "error_messages" : {
                                                    "min_error" : "You have to enter atleast 2 characters",
                                                    "max_error" : "You cant enter more than 30 characters",
                                                    "pattern_error" : "Please enter the appropriate title",
                                                    "required_error" : "This field is mandatory"
                                                }
                                            }, 
                                            {
                                                "type" : "text",
                                                "id" : "first_name",
                                                "show" : true,
                                                "label" : "Name",
                                                "size" : "col-lg-12 col-md-12 col-sm-12 ",
                                                "name" : "first_name",
                                                "placeholder" : "Eg: Kevin",
                                                "show" : true,
                                                "validators" : {
                                                    "required" : true,
                                                    "pattern" : [],
                                                    "min_length" : 1,
                                                    "max_length" : 45
                                                },
                                                "error_messages" : {
                                                    "min_error" : "You have to enter atleast 1 characters",
                                                    "max_error" : "You cant enter more than 45 characters",
                                                    "pattern_error" : "",
                                                    "required_error" : "This field is mandatory"
                                                }
                                            }, 
                                            {
                                                "type" : "note",
                                                "name" : "note_for_name",
                                                "alert_type" : "primary",
                                                "trigger" : "!",
                                                "label" : "Please enter name as per Passport",
                                                "size" : "col-lg-12 col-md-12 col-sm-12 ",
                                                "show" : "true"
                                            }, 
                                            {
                                                "type" : "text",
                                                "id" : "middle_name",
                                                "label" : "Middle name",
                                                "size" : "col-lg-12 col-md-12 col-sm-12 ",
                                                "name" : "middle_name",
                                                "placeholder" : "Eg: James",
                                                "show" : true,
                                                "show" : true,
                                                "size" : "col-lg-12 col-md-12 col-sm-12 ",
                                                "name" : "last_name",
                                                "placeholder" : "Eg: Potter",
                                                "show" : true,
                                                "validators" : {
                                                    "required" : true,
                                                    "pattern" : [],
                                                    "min_length" : "",
                                                    "max_length" : ""
                                                },
                                                "error_messages" : {
                                                    "min_error" : "",
                                                    "max_error" : "",
                                                    "pattern_error" : "",
                                                    "required_error" : "This field is mandatory"
                                                }
                                            }, 
                                            {
                                                "type" : "dob",
                                                "id" : "birth_date",
                                                "label" : "Date of Birth",
                                                "name" : "birth_date",
                                                "size" : "col-lg-12 col-md-12 col-sm-12 ",
                                                "placeholder" : "Eg: 12/11/1995",
                                                "show" : true,
                                                "validators" : {
                                                    "required" : true,
                                                    "pattern" : [],
                                                    "min_length" : "",
                                                    "max_length" : ""
                                                },
                                                "error_messages" : {
                                                    "min_error" : "",
                                                    "max_error" : "",
                                                    "pattern_error" : "",
                                                    "required_error" : "This field is mandatory"
                                                }
                                            }, 
                                            {
                                                "type" : "note",
                                                "alert_type" : "danger",
                                                "trigger" : "!",
                                                "name" : "note_for_minor",
                                                "label" : "The applicant is minor. Can't Proceed further",
                                                "size" : "col-lg-12 col-md-12 col-sm-12 ",
                                                "show" : "recursive.recursiveFormData.majority === \"Minor\""
                                            }, 
                                            {
                                                "type" : "mobile",
                                                "id" : "mobile_number",
                                                "size" : "col-lg-12 col-md-12 col-sm-12 ",
                                                "label" : "Mobile No",
                                                "name" : "mobile_number",
                                                "placeholder" : "Mobile Number",
                                                "show" : true,
                                                "validators" : {
                                                    "required" : true,
                                                    "pattern" : [ 
                                                        "^[1-9]+[0-9]+$"
                                                    ],
                                                    "min_length" : "4",
                                                    "max_length" : "13"
                                                },
                                                "error_messages" : {
                                                    "min_error" : "Mobile No is invalid",
                                                    "max_error" : "Mobile No is invalid",
                                                    "pattern_error" : "Mobile no is invalid",
                                                    "required_error" : "This field is mandatory"
                                                }
                                            }, 
                                            {
                                                "type" : "email",
                                                "id" : "email",
                                                "show" : true,
                                                "label" : "Email address",
                                                "size" : "col-lg-12 col-md-12 col-sm-12 ",
                                                "name" : "email",
                                                "placeholder" : "Enter your email",
                                                "show" : true,
                                                "validators" : {
                                                    "required" : true,
                                                    "pattern" : [ 
                                                        "^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]+$"
                                                    ],
                                                    "min_length" : "",
                                                    "max_length" : ""
                                                },
                                                "error_messages" : {
                                                    "min_error" : "",
                                                    "max_error" : "",
                                                    "pattern_error" : "",
                                                    "required_error" : "This field is mandatory"
                                                },
                                                "events" : {
                                                    "onKeyUpCapture" : "checkPreviousEnteredEmails(`email`)"
                                                }
                                            }, 
                                            {
                                                "type" : "dropdown",
                                                "id" : "nationality",
                                                "label" : "Nationality",
                                                "size" : "col-lg-12 col-md-12 col-sm-12 ",
                                                "name" : "nationality",
                                                "options_type" : "globalNationality",
                                                "show" : true,
                                                "validators" : {
                                                    "required" : true,
                                                    "pattern" : [],
                                                    "min_length" : "",
                                                    "max_length" : ""
                                                },
                                                "error_messages" : {
                                                    "min_error" : "You have to enter atleast <x> characters",
                                                    "max_error" : "You can't enter more than <x> characters",
                                                    "pattern_error" : "Please select the appropriate nationality",
                                                    "required_error" : "This field is mandatory"
                                                }
                                            }, 
                                            {
                                                "type" : "dropdown",
                                                "id" : "residence_country",
                                                "label" : "Country of Residence",
                                                "name" : "residence_country",
                                                "size" : "col-lg-12 col-md-12 col-sm-12 ",
                                                "options_type" : "globalCountries",
                                                "show" : true,
                                                "validators" : {
                                                    "required" : true,
                                                    "pattern" : [],
                                                    "min_length" : "",
                                                    "max_length" : ""
                                                },
                                                "error_messages" : {
                                                    "min_error" : "You have to enter atleast <x> characters",
                                                    "max_error" : "You can't enter more than <x> characters",
                                                    "pattern_error" : "Please select the appropriate country of residence",
                                                    "required_error" : "This field is mandatory"
                                                }
                                            }, 
                                            {
                                                "type" : "radio",
                                                "id" : "citizenship",
                                                "label" : "Citizenship",
                                                "name" : "citizenship",
                                                "show" : true,
                                                "tooltip" : [ 
                                                    {
                                                        "alert_type" : "primary",
                                                        "tooltip_text" : " If you are an overseas citizen of India, upload your OCI card",
                                                        "trigger" : "!"
                                                    }
                                                ],
                                                "size" : "col-lg-6 col-md-6 col-12 ",
                                                "options" : [ 
                                                    {
                                                        "label" : "Single",
                                                        "id" : "option1",
                                                        "for" : "option1"
                                                    }, 
                                                    {
                                                        "label" : "Dual",
                                                        "id" : "option2",
                                                        "for" : "option2"
                                                    }
                                                ],
                                                "validators" : {
                                                    "required" : true,
                                                    "pattern" : [],
                                                    "min_length" : "",
                                                    "max_length" : ""
                                                },
                                                "error_messages" : {
                                                    "min_error" : "You have to enter atleast <x> characters",
                                                    "max_error" : "You can't enter more than <x> characters",
                                                    "pattern_error" : "Please select appropriate citizenship",
                                                    "required_error" : "This field is mandatory"
                                                }
                                            }, 
                                            {
                                                "type" : "dropdown",
                                                "id" : "citizenship_country_name",
                                                "label" : "Citizenship country name",
                                                "name" : "citizenship_country_name",
                                                "size" : "col-lg-12 col-md-12 col-sm-12 ",
                                                "show" : "recursive.recursiveFormData.citizenship == \"Single\" ",
                                                "options_type" : "globalCountries",
                                                "validators" : {
                                                    "required" : true,
                                                    "pattern" : [],
                                                    "min_length" : "",
                                                    "max_length" : ""
                                                },
                                                "error_messages" : {
                                                    "min_error" : "",
                                                    "max_error" : "",
                                                    "pattern_error" : "",
                                                    "required_error" : "This field is mandatory"
                                                }
                                            }, 
                                            {
                                                "type" : "dropdown",
                                                "id" : "first_citizenship_country_name",
                                                "label" : "First citizenship country name",
                                                "name" : "first_citizenship_country_name",
                                                "show" : "recursive.recursiveFormData.citizenship == \"Dual\"",
                                                "options_type" : "globalCountries",
                                                "validators" : {
                                                    "required" : true,
                                                    "pattern" : [],
                                                    "min_length" : "",
                                                    "max_length" : ""
                                                },
                                                "error_messages" : {
                                                    "min_error" : "",
                                                    "max_error" : "",
                                                    "pattern_error" : "",
                                                    "required_error" : "This field is mandatory"
                                                }
                                            }, 
                                            {
                                                "type" : "dropdown",
                                                "id" : "second_citizenship_country_name",
                                                "label" : "Second citizenship country name",
                                                "name" : "second_citizenship_country_name",
                                                "show" : "recursive.recursiveFormData.citizenship == \"Dual\"",
                                                "options_type" : "globalCountries",
                                                "validators" : {
                                                    "required" : true,
                                                    "pattern" : [],
                                                    "min_length" : "",
                                                    "max_length" : ""
                                                },
                                                "error_messages" : {
                                                    "min_error" : "You have to enter atleast <x> characters",
                                                    "max_error" : "You can't enter more than <x> characters",
                                                    "pattern_error" : "Please select appropriate country name",
                                                    "required_error" : "This field is mandatory"
                                                }
                                            }
                                        ],
                                        "recursive_actions" : [ 
                                            {
                                                "label" : "Cancel",
                                                "action" : "cancel",
                                                "show" : "(formData.selectedData.mode_of_operation == \"Jointly\" && recursive.saveData.length == 0) || (showRecursiveForm == true && recursive.saveData.length > 0) || (isEditRecursiveForm == true && recursive.saveData.length == 0)"
                                            }, 
                                            {
                                                "label" : "Next",
                                                "action" : "add",
                                                "disabled" : "recursive.recursiveFormData.majority === \"Minor\" || (selectedData?.first_citizenship_country_name == selectedData?.second_citizenship_country_name && recursive.recursiveFormData.citizenship == \"Dual\")",
                                                "show" : "(recursive.saveData.length == 0) || (showRecursiveForm == true && isEditRecursiveForm == false)"
                                            }, 
                                            {
                                                "label" : "Update",
                                                "action" : "edit",
                                                "disabled" : "recursive.recursiveFormData.majority === \"Minor\" || (recursive.recursiveFormData?.first_citizenship_country_name == recursive.recursiveFormData?.second_citizenship_country_name && recursive.recursiveFormData.citizenship == \"Dual\")",
                                                "show" : "showRecursiveForm == true && isEditRecursiveForm == true"
                                            }, 
                                            {
                                                "label" : "Add another member",
                                                "action" : "addNew",
                                                "show" : "showRecursiveForm == false && isEditRecursiveForm == false && recursive.saveData.length > 0 && formData.selectedData.mode_of_operation == \"Jointly\""
                                            }
                                        ]
                                    }
                                ],
                                "form_buttons" : [ 
                                    {
                                        "label" : "Back",
                                        "action" : "back",
                                        "show" : "true"
                                    }, 
                                    {
                                        "label" : "Next",
                                        "action" : "next",
                                        "disabled" : "(formData.selectedData.mode_of_operation == \"Jointly\" && recursive.saveData.length < 2) || (showRecursiveForm == true && recursive.saveData.length > 0) || (isEditRecursiveForm == true && recursive.saveData.length == 0) || (recursive.saveData.length < recursive.minLength)",
                                        "show" : "formData.selectedData.mode_of_operation == \"Jointly\"",
                                        "confirmation_content" : {
                                            "content" : "Before proceeding, make sure that all the form details are entered correctly. The details cannot be edited once the OTP is submitted.",
                                            "button" : {
                                                "label" : "Next",
                                                "action" : "next",
                                                "disabled" : "(formData.selectedData.mode_of_operation == \"Jointly\" && recursive.saveData.length < 2) || (showRecursiveForm == true && recursive.saveData.length > 0) || (isEditRecursiveForm == true && recursive.saveData.length == 0) || (recursive.saveData.length < recursive.minLength)",
                                                "show" : "formData.selectedData.mode_of_operation == \"Jointly\""
                                            }
                                        }
                                    }, 
                                    {
                                        "label" : "Submit",
                                        "action" : "next",
                                        "id" : [ 
                                            "63f48cda0da9a2e48b313d81"
                                        ],
                                        "trigger" : "userinitiated",
                                        "disabled" : "isEditRecursiveForm == true || recursive.saveData.length == 0",
                                        "show" : "formData.selectedData.mode_of_operation != \"Jointly\"",
                                        "confirmation_content" : {
                                            "content" : "Before proceeding, make sure that all the form details are entered correctly. The details cannot be edited once the OTP is submitted.",
                                            "button" : {
                                                "label" : "Next",
                                                "action" : "next",
                                                "disabled" : "(formData.selectedData.mode_of_operation == \"Jointly\" && recursive.saveData.length < 2) || (showRecursiveForm == true && recursive.saveData.length > 0) || (isEditRecursiveForm == true && recursive.saveData.length == 0) || (recursive.saveData.length < recursive.minLength)",
                                                "show" : "formData.selectedData.mode_of_operation == \"Jointly\""
                                            }
                                        }
                                    },
                                    {
                                        "label" : "Authenticate with UAE pass",
                                        "action" : "uae_pass_auth",
                                        "trigger" : "userinitiated",
                                        "disabled" : "isEditRecursiveForm == true || recursive.saveData.length == 0",
                                        "show" : "formData.selectedData.mode_of_operation != \"Jointly\"",
                                        "confirmation_content" : {
                                            "content" : "Before proceeding, make sure that all the form details are entered correctly. You will be redirected another page.",
                                            "button" : {
                                                "label" : "Next",
                                                "action" : "uae_pass_auth",
                                                "disabled" : "(formData.selectedData.mode_of_operation == \"Jointly\" && recursive.saveData.length < 2) || (showRecursiveForm == true && recursive.saveData.length > 0) || (isEditRecursiveForm == true && recursive.saveData.length == 0) || (recursive.saveData.length < recursive.minLength)",
                                                "show" : "formData.selectedData.mode_of_operation == \"Jointly\""
                                            }
                                        }
                                    }
                                ]
                            }, 
                            {
                                "title" : "Applicant Consents",
                                "name" : "applicant_consent",
                                "order" : 3,
                                "show" : "false",
                                "next_step" : 4,
                                "form_elements" : [ 
                                    {
                                        "name" : "i_want_to_create_account",
                                        "type" : "consent",
                                        "layout" : "regular",
                                        "consents" : [ 
                                            {
                                                "title" : "I want to create an Account",
                                                "name" : "privacy_consent",
                                                "label" : "Privacy Consent",
                                                "consent_id" : "6396fe3c5f0c894cfb56cf47"
                                            }
                                        ]
                                    }
                                ],
                                "form_buttons" : [ 
                                    {
                                        "label" : "Proceed",
                                        "action" : "next",
                                        "disabled" : "!formData?.selectedData?.consents?.i_want_to_create_account"
                                    }
                                ]
                            }, 
                            {
                                "title" : "OTP Verification",
                                "name" : "otp_verification",
                                "order" : 4,
                                "show" : "true",
                                "next_step" : 5,
                                "form_elements" : [ 
                                    {
                                        "type" : "note",
                                        "name" : "note_for_otp",
                                        "alert_type" : "primary",
                                        "trigger" : "!",
                                        "label" : "Please do not refresh the page",
                                        "size" : "col-lg-12 col-md-12 col-sm-12 ",
                                        "show" : true
                                    }, 
                                    {
                                        "type" : "subheader",
                                        "name" : "otp_verification",
                                        "label" : "Verification"
                                    }, 
                                    {
                                        "type" : "otp",
                                        "id" : "email_otp",
                                        "name" : "email_otp",
                                        "label" : "Enter the email verification code sent to",
                                        "masking_type" : "password",
                                        "otp_length" : 6
                                    }, 
                                    {
                                        "type" : "otp",
                                        "id" : "whatsapp_otp",
                                        "name" : "whatsapp_otp",
                                        "show" : "applicantUser?.is_verified == true ? false: true",
                                        "label" : "Enter the Whatsapp verification (optional) code sent to",
                                        "masking_type" : "password",
                                        "otp_length" : 6
                                    }
                                ],
                                "form_buttons" : [ 
                                    {
                                        "label" : "Next",
                                        "action" : "next",
                                        "disabled" : "applicantUser?.is_verified == true ? otpReducer?.otpResponse?.email_otp?.status != \"success\" : (otpReducer?.otpResponse?.email_otp?.status != \"success\" || otpReducer?.otpResponse?.whatsapp_otp?.status == \"Failed\")",
                                        "show" : "!userInfo?.primaryUser?.created_by"
                                    }, 
                                    {
                                        "label" : "Submit",
                                        "action" : "next",
                                        "show" : "userInfo?.primaryUser?.created_by != null",
                                        "disabled" : "applicantUser?.is_verified == true ? otpReducer?.otpResponse?.email_otp?.status != \"success\" : (otpReducer?.otpResponse?.email_otp?.status != \"success\" || otpReducer?.otpResponse?.whatsapp_otp?.status == \"Failed\")"
                                    }
                                ]
                            }, 
                            {
                                "title" : "Preview Data",
                                "name" : "preview_data",
                                "order" : 5,
                                "show" : "true",
                                "form_elements" : [ 
                                    {
                                        "type" : "view_card",
                                        "title" : "Application Details",
                                        "show" : "true",
                                        "input_fields" : [ 
                                            {
                                                "name" : "application_type",
                                                "label" : "Type of client",
                                                "size" : "col-4"
                                            }, 
                                            {
                                                "name" : "service_type",
                                                "label" : "Type of service",
                                                "size" : "col-5"
                                            }, 
                                            {
                                                "name" : "mode_of_operation",
                                                "label" : "Mode of operation",
                                                "size" : "col-5"
                                            }
                                        ]
                                    }, 
                                    {
                                        "type" : "action_card",
                                        "title" : "Choose a verified applicant to proceed further",
                                        "show" : "true",
                                        "input_fields" : [ 
                                            {
                                                "name" : "profile_icon",
                                                "expression" : "getProfileChars(first_name,1)"
                                            }, 
                                            {
                                                "name" : "first_name"
                                            }, 
                                            {
                                                "name" : "mobile_country_code"
                                            }, 
                                            {
                                                "name" : "mobile_number"
                                            }, 
                                            {
                                                "name" : "email"
                                            }
                                        ],
                                        "flags" : {
                                            "is_verified" : "selectedData.applicant_status",
                                            "applicant_type" : "selectedData.applicant_type"
                                        }
                                    }
                                ],
                                "form_buttons" : [ 
                                    {
                                        "label" : "Proceed",
                                        "action" : "next",
                                        "show" : "false"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    ],
    "wf_decider_backup" : [ 
        {
            "show" : "selectedData.account_type == \"Individual\"",
            "value" : "63dbb5c0408205109e9e8c9e"
        }
    ],
    "wf_decider" : [ 
        {
            "show" : true,
            "value" : "64f9c76c812a032339a18e37",
            "user_initiated" : true
        }
    ]
}